import appGlobalScript from '/Users/gerardbalaoro/Projects/design-system-web/src/global.ts';
export const globalScripts = appGlobalScript;
